class ComponentAccordion extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();
  }

  toggleAccordion(detail, element) {
    const button = element;
    const item = button.closest('.accordion-item');
    const items = this.querySelectorAll('.accordion-item');
    const nextState = !item.classList.contains('is-active');

    items.forEach((accordionItem) => {
      const header = accordionItem.querySelector('.accordion-header');
      const isActive = accordionItem === item ? nextState : false;

      accordionItem.classList.toggle('is-active', isActive);

      if (header) {
        header.setAttribute('aria-expanded', String(isActive));
      }
    });
  }

  setAccordionState(activeKey, activeState) {
    const items = this.querySelectorAll('.accordion-item');

    items.forEach((accordionItem) => {
      const header = accordionItem.querySelector(`.accordion-header[data-key="${activeKey}"]`);
      const isActive = !!header && activeState;
      const targetHeader = accordionItem.querySelector('.accordion-header');

      accordionItem.classList.toggle('is-active', isActive);

      if (targetHeader) {
        targetHeader.setAttribute('aria-expanded', String(isActive));
      }
    });
  }
}

customElements.define('component-accordion', ComponentAccordion);